export default {
  'pages.covenantDevice.mac': 'MAC-Adresse',
  'pages.admin.providerCard.config.grpcAddr': 'gRPC-Adresse',
  'pages.covenantDevice.cardTitle': 'Vertragsgeräteverwaltung',
  'pages.admin.whitelist.mac': 'MAC-Adresse',
  'pages.covenantDevice.operations': 'Aktionen',
  'pages.covenantDevice.expireTime': 'Ablaufzeit',
  'pages.covenantDevice.updateTime': 'Aktualisierungszeit',
  'pages.unbindDevice.titleAdmin': 'Gerät entbinden (Admin erforderlich)',
  'pages.unbindDevice.inputPlaceholder': 'Bitte Geräte-ID eingeben',
  'pages.unbindDevice.unbind': 'Entbinden',
  'pages.unbindDevice.unbinding': 'Entbinde...',
  'pages.unbindDevice.success': 'Erfolgreich entbunden',
  'pages.unbindDevice.fail': 'Entbinden fehlgeschlagen',
  'pages.layouts.userLayout.title': 'Verwaltungskonsole',
  'pages.login.accountLogin.tab': 'Konto-Anmeldung',
  'pages.login.accountLogin.errorMessage':
    'Falscher Benutzername/Passwort(admin/ant.design)',
  'pages.login.failure': 'Anmeldung fehlgeschlagen, bitte versuchen Sie es erneut!',
  'pages.login.success': 'Anmeldung erfolgreich!',
  'pages.login.username.placeholder': 'Benutzername: admin oder user',
  'pages.login.username.required': 'Bitte geben Sie Ihren Benutzernamen ein!',
  'pages.login.password.placeholder': 'Passwort: ant.design',
  'pages.login.password.required': 'Bitte geben Sie Ihr Passwort ein!',
  'pages.login.phoneLogin.tab': 'Telefon-Anmeldung',
  'pages.login.phoneLogin.errorMessage': 'Verifizierungscode-Fehler',
  'pages.login.phoneNumber.placeholder': 'Telefonnummer',
  'pages.login.phoneNumber.required': 'Bitte geben Sie Ihre Telefonnummer ein!',
  'pages.login.phoneNumber.invalid': 'Telefonnummer ist ungültig!',
  'pages.login.captcha.placeholder': 'Verifizierungscode',
  'pages.login.captcha.required': 'Bitte geben Sie den Verifizierungscode ein!',
  'pages.login.phoneLogin.getVerificationCode': 'Code abrufen',
  'pages.getCaptchaSecondText': 'Sek.',
  'pages.login.rememberMe': 'Angemeldet bleiben',
  'pages.login.forgotPassword': 'Passwort vergessen?',
  'pages.login.submit': 'Anmelden',
  'pages.login.loginWith': 'Anmelden mit:',
  'pages.login.registerAccount': 'Konto registrieren',
  'pages.welcome.link': 'Willkommen',
  'pages.welcome.alertMessage':
    'Schnellere und stärkere Heavy-Duty-Komponenten wurden veröffentlicht.',
  'pages.404.subTitle': 'Entschuldigung, die Seite, die Sie besucht haben, existiert nicht.',
  'pages.404.buttonText': 'Zur Startseite',
  'pages.admin.subPage.title': 'Diese Seite kann nur vom Admin angezeigt werden',
  'pages.admin.subPage.alertMessage':
    'Umi ui ist jetzt veröffentlicht, verwenden Sie npm run ui, um die Erfahrung zu starten.',
  'pages.searchTable.createForm.newRule': 'Neue Regel',
  'pages.searchTable.updateForm.ruleConfig': 'Regelkonfiguration',
  'pages.searchTable.updateForm.basicConfig': 'Grundinformationen',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Regelname',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Bitte geben Sie den Regelnamen ein!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Regelbeschreibung',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Bitte geben Sie mindestens fünf Zeichen ein',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Bitte geben Sie eine Regelbeschreibung von mindestens fünf Zeichen ein!',
  'pages.searchTable.updateForm.ruleProps.title': 'Eigenschaften konfigurieren',
  'pages.searchTable.updateForm.object': 'Überwachungsobjekt',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Regelvorlage',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Regeltyp',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Planungsperiode festlegen',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Startzeit',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Bitte wählen Sie eine Startzeit!',
  'pages.searchTable.titleDesc': 'Beschreibung',
  'pages.searchTable.ruleName': 'Regelname ist erforderlich',
  'pages.searchTable.titleCallNo': 'Anzahl Serviceanrufe',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'Standard',
  'pages.searchTable.nameStatus.running': 'läuft',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Zuletzt geplant am',
  'pages.searchTable.exception': 'Bitte geben Sie den Grund für die Ausnahme ein!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Konfiguration',
  'pages.searchTable.subscribeAlert': 'Warnungen abonnieren',
  'pages.searchTable.title': 'Abfrageformular',
  'pages.searchTable.new': 'Neu',
  'pages.searchTable.chosen': 'ausgewählt',
  'pages.searchTable.item': 'Element',
  'pages.searchTable.totalServiceCalls': 'Gesamtanzahl Serviceanrufe',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'Stapellöschung',
  'pages.searchTable.batchApproval': 'Stapelgenehmigung',
  
  // Agents page related text
  'pages.agents.search.placeholder': 'Agenten suchen',
  'pages.agents.create.button': 'Agent erstellen',
  'pages.agents.addDevice.button': 'Gerät hinzufügen',
  'pages.agents.create.modal.title': 'Agent erstellen',
  'pages.agents.create.modal.nameLabel': 'Agentenname',
  'pages.agents.create.modal.placeholder': 'Bitte Agentennamen eingeben',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': 'Sprachmodell',
  'pages.agents.card.languageModel': 'Sprachmodell',
  'pages.agents.card.lastChat': 'Letzter Chat',
  'pages.agents.card.conversationId': 'Unterhaltungs-ID',
  'pages.agents.card.clearConversation': 'Unterhaltungs-ID löschen',
  'pages.agents.card.clearConversation.success': 'Unterhaltungs-ID gelöscht',
  'pages.agents.card.clearConversation.error': 'Fehler beim Löschen der Unterhaltungs-ID',
  'pages.agents.card.configRole': 'Rolle konfigurieren',
  'pages.agents.card.voiceRecognition': 'Spracherkennung',
  'pages.agents.card.voiceRecognition.developing': 'Funktion in Entwicklung, bleiben Sie dran',
  'pages.agents.card.historyDialog': 'Verlaufsdialog',
  'pages.agents.card.manageDevice': 'Geräte verwalten',
  'pages.agents.card.addDevice': 'Gerät hinzufügen',
  'pages.agents.loading': 'Lade Agentenliste...',
  'pages.agents.reload': 'Neu laden',
  'pages.agents.empty.title': 'Keine Agenten verfügbar',
  'pages.agents.empty.createFirst': 'Erstellen Sie Ihren ersten Agenten',
  'pages.agents.delete.title': 'Agent löschen bestätigen',
  'pages.agents.delete.content': 'Nach dem Löschen des Agenten können alle zugehörigen Konfigurationen (einschließlich gerätebezogener Unterhaltungsaufzeichnungen) nicht wiederhergestellt werden. Sind Sie sicher, dass Sie löschen möchten?',
  'pages.agents.delete.confirm': 'Löschen bestätigen',
  'pages.agents.fetch.error': 'Fehler beim Laden der Agentenliste',
  'pages.agents.network.error': 'Netzwerkfehler, bitte versuchen Sie es später erneut',
  'pages.agents.speed.patient': 'Geduldig',
  'pages.agents.speed.normal': 'Normal',
  'pages.agents.speed.fast': 'Schnell',
  'pages.agents.lastChat.none': 'Keine',
  'pages.agents.language.chinese': 'Chinesisch',
  'pages.agents.loading.tts.error': 'Fehler beim Laden der TTS-Stimmen',
  'pages.agents.loading.llm.error': 'Fehler beim Laden der LLM-Anbieter',
  'pages.agents.sort.id': 'Nach ID sortieren',
  'pages.agents.sort.updatedAt': 'Nach letzter Änderung',
  'pages.agents.sort.lastConversationAt': 'Nach letzter Unterhaltung',
  
  // Register page related text
  'pages.register': 'Registrieren',
  'pages.register.title': 'Registrieren',
  'pages.register.form.title': 'Neues Konto registrieren',
  'pages.register.submit': 'Registrieren',
  'pages.register.username.placeholder': 'Bitte Benutzername eingeben',
  'pages.register.username.required': 'Bitte Benutzername eingeben!',
  'pages.register.username.min': 'Benutzername muss mindestens 4 Zeichen haben',
  'pages.register.email.placeholder': 'Bitte E-Mail eingeben',
  'pages.register.email.required': 'Bitte E-Mail eingeben!',
  'pages.register.email.invalid': 'Bitte gültige E-Mail-Adresse eingeben!',
  'pages.register.password.placeholder': 'Bitte Passwort eingeben',
  'pages.register.password.required': 'Bitte Passwort eingeben!',
  'pages.register.password.min': 'Passwort muss mindestens 6 Zeichen haben',
  'pages.register.password.pattern': 'Passwort muss Groß-, Kleinbuchstaben und Zahlen enthalten',
  'pages.register.confirmPassword.placeholder': 'Bitte Passwort bestätigen',
  'pages.register.confirmPassword.required': 'Bitte Passwort bestätigen!',
  'pages.register.confirmPassword.min': 'Passwort muss mindestens 6 Zeichen haben',
  'pages.register.error.passwordMismatch': 'Die beiden Passwörter stimmen nicht überein',
  'pages.register.error.registerFailed': 'Registrierung fehlgeschlagen, bitte versuchen Sie es erneut!',
  'pages.register.success': 'Registrierung erfolgreich!',
  
  // Login page related text
  'pages.login.title': 'Anime AI Chat Verwaltungskonsole',
  'pages.login.actionIcons.notImplemented': 'Noch nicht implementiert, kommt bald',
  'pages.login.mobile.captchaError': 'Verifizierungscode-Fehler',
  'pages.login.captcha.success': 'Verifizierungscode erfolgreich gesendet! Code: 1234',
  'pages.login.forgotPassword.contactAdmin': 'Bitte kontaktieren Sie den Administrator',
  'pages.login.mobile.notAvailable': 'Diese Funktion ist noch nicht verfügbar, bitte verwenden Sie die Konto-Anmeldung',
  
  // AgentSetting page related text
  'pages.agentSetting.title': 'Rolle konfigurieren',
  'pages.agentSetting.back': 'Zurück',
  'pages.agentSetting.roleTemplate.title': 'Rollenvorlage',
  'pages.agentSetting.roleTemplate.label': 'Vorlage',
  'pages.agentSetting.template.taiwanGirlfriend': 'Taiwan-Freundin',
  'pages.agentSetting.template.potato': 'Kartoffel',
  'pages.agentSetting.template.englishTutor': 'Englisch-Tutor',
  'pages.agentSetting.template.curiousBoy': 'Neugieriger Junge',
  'pages.agentSetting.template.puppyLeader': 'Welpen-Anführer',
  'pages.agentSetting.basicConfig.title': 'Grundkonfiguration',
  'pages.agentSetting.assistantName.label': 'Assistentenname',
  'pages.agentSetting.assistantName.placeholder': 'Bitte Assistentennamen eingeben',
  'pages.agentSetting.assistantName.required': 'Bitte Assistentennamen eingeben',
  'pages.agentSetting.dialogLanguage.label': 'Dialogsprache',
  'pages.agentSetting.dialogLanguage.placeholder': 'Dialogsprache auswählen',
  'pages.agentSetting.voiceType.label': 'Stimmtyp',
  'pages.agentSetting.voiceType.placeholder': 'Stimmtyp auswählen',
  'pages.agentSetting.roleDescription.title': 'Rollenbeschreibung',
  'pages.agentSetting.roleDescription.label': 'Rollenbeschreibung',
  'pages.agentSetting.roleDescription.placeholder': 'Bitte Rollenbeschreibung eingeben',
  'pages.agentSetting.roleDescription.required': 'Bitte Rollenbeschreibung eingeben',
  'pages.agentSetting.languageModel.title': 'Sprachmodell',
  'pages.agentSetting.languageModel.label': 'Sprachmodell',
  'pages.agentSetting.languageModel.placeholder': 'Sprachmodell auswählen',
  'pages.agentSetting.languageModel.tip': 'Nach einer Modelländerung wird empfohlen, den Speicher zu löschen, um die Chat-Erfahrung nicht zu beeinträchtigen.',
  'pages.agentSetting.advancedSettings.expand': 'Erweiterte Einstellungen ausklappen',
  'pages.agentSetting.advancedSettings.collapse': 'Erweiterte Einstellungen einklappen',
  'pages.agentSetting.recognitionSpeed.label': 'Spracherkennungsgeschwindigkeit',
  'pages.agentSetting.recognitionSpeed.placeholder': 'Erkennungsgeschwindigkeit auswählen',
  'pages.agentSetting.speechSpeed.label': 'Sprechgeschwindigkeit',
  'pages.agentSetting.speechSpeed.placeholder': 'Sprechgeschwindigkeit auswählen',
  'pages.agentSetting.pitchValue.label': 'Charakterlautstärke',
  'pages.agentSetting.button.reset': 'Zurücksetzen',
  'pages.agentSetting.button.save': 'Speichern',
  'pages.agentSetting.save.success': 'Erfolgreich gespeichert',
  'pages.agentSetting.save.error': 'Speichern fehlgeschlagen',
  'pages.agentSetting.save.missingId': 'Fehlende Agenten-ID, kann nicht gespeichert werden',
  'pages.agentSetting.load.tts.error': 'Fehler beim Laden der TTS-Stimmen',
  'pages.agentSetting.speed.slow': 'Langsam',
  'pages.agentSetting.speed.normal': 'Normal',
  'pages.agentSetting.speed.fast': 'Schnell',
  'pages.agentSetting.speed.patient': 'Geduldig',
  'pages.agentSetting.language.chinese': 'Chinesisch',
  'pages.agentSetting.language.english': 'Englisch',
  'pages.agentSetting.language.spanish': 'Spanisch',
  'pages.agentSetting.language.french': 'Französisch',
  'pages.agentSetting.language.german': 'Deutsch',
  'pages.agentSetting.language.japanese': 'Japanisch',
  'pages.agentSetting.language.korean': 'Koreanisch',
  'pages.agentSetting.language.portuguese': 'Portugiesisch',
  'pages.agentSetting.language.arabic': 'Arabisch',
  'pages.agentSetting.language.russian': 'Russisch',
  'pages.agentSetting.language.italian': 'Italienisch',
  'pages.agentSetting.language.turkish': 'Türkisch',
  'pages.agentSetting.language.polish': 'Polnisch',
  'pages.agentSetting.language.catalan': 'Katalanisch',

  // DeviceManagement page related text
  'pages.devices.title': 'Geräte verwalten',
  'pages.devices.breadcrumb.agents': 'Agenten',
  'pages.devices.breadcrumb.devices': 'Geräte verwalten',
  'pages.devices.button.addDevice': 'Gerät hinzufügen',
  'pages.devices.warning.noAgentId': 'Keine agentId angegeben, kann Geräteliste nicht abrufen',
  'pages.devices.device.unnamed': 'Unbenanntes Gerät',
  'pages.devices.device.macAddress': 'MAC-Adresse',
  'pages.devices.device.lastActive': 'Zuletzt aktiv',
  'pages.devices.device.firmwareVersion': 'Firmware-Version',
  'pages.devices.device.otaUpgrade': 'OTA-Upgrade',
  'pages.devices.device.noData': 'Keine Daten',
  'pages.devices.copy.success': 'MAC-Adresse kopiert',
  'pages.devices.unbind.title': 'Gerät entbinden bestätigen',
  'pages.devices.unbind.content': 'Das Entbinden des Geräts kann nicht rückgängig gemacht werden. Wenn Sie es wieder verwenden möchten, müssen Sie es erneut binden. Sind Sie sicher, dass Sie es entbinden möchten?',
  'pages.devices.unbind.confirm': 'Entbinden bestätigen',
  'pages.devices.unbind.cancel': 'Abbrechen',
  'pages.devices.unbind.success': 'Gerät entbunden',
  'pages.devices.unbind.error': 'Entbinden fehlgeschlagen',
  'pages.devices.ota.enabled': 'OTA-Upgrade aktiviert',
  'pages.devices.ota.disabled': 'OTA-Upgrade deaktiviert',
  
  // HistoryDialogs page related text
  'pages.historyDialogs.title': 'Verlaufsdialoge',
  'pages.historyDialogs.breadcrumb.agents': 'Agenten',
  'pages.historyDialogs.breadcrumb.historyDialogs': 'Verlaufsdialoge',
  'pages.historyDialogs.empty.title': 'Keine Unterhaltung ausgewählt',
  'pages.historyDialogs.empty.description': 'Bitte wählen Sie eine Unterhaltung aus',
  'pages.historyDialogs.agent': 'Agent',
  'pages.historyDialogs.agent.id': 'ID',
  'pages.historyDialogs.conversationDetail': 'Unterhaltungsdetails',
  'pages.historyDialogs.selectConversation': 'Bitte wählen Sie eine Unterhaltung aus',
  'pages.historyDialogs.delete.title': 'Unterhaltung löschen',
  'pages.historyDialogs.delete.content': 'Die Unterhaltung kann nach dem Löschen nicht wiederhergestellt werden. Bitte bestätigen Sie den Vorgang.',
  'pages.historyDialogs.delete.confirm': 'Bestätigen',
  'pages.historyDialogs.delete.cancel': 'Abbrechen',
  'pages.historyDialogs.message.delete.confirm': 'Sind Sie sicher, dass Sie diese Nachricht löschen möchten? Sie kann nach dem Löschen nicht wiederhergestellt werden.',
  'pages.historyDialogs.detail.title': 'Unterhaltungsdetails',
  'pages.historyDialogs.agent.label': 'Agent:',
  'pages.historyDialogs.user.label': 'Benutzer:',
  'pages.historyDialogs.loading': 'Lädt...',
  'pages.historyDialogs.error.loadFailed': 'Fehler beim Laden der Unterhaltungsliste',
  'pages.historyDialogs.error.deleteFailed': 'Fehler beim Löschen der Unterhaltung',
  'pages.historyDialogs.success.deleteSuccess': 'Unterhaltung erfolgreich gelöscht',
  
  // MessageList page related text
  'pages.messageList.empty': 'Keine Nachrichten',
  'pages.messageList.user': 'Benutzer',
  'pages.messageList.ai': 'KI',
  
  // Settings page related text
  'pages.settings.basicInfo.title': 'Grundinformationen',
  'pages.settings.avatar.label': 'Avatar:',
  'pages.settings.avatar.change': 'Avatar ändern',
  'pages.settings.avatar.updateSuccess': 'Avatar erfolgreich aktualisiert',
  'pages.settings.avatar.updateFailed': 'Fehler beim Aktualisieren des Avatars',
  'pages.settings.username.label': 'Benutzername:',
  'pages.settings.nickname.label': 'Spitzname:',
  'pages.settings.nickname.change': 'Spitzname bearbeiten',
  'pages.settings.nickname.modal.title': 'Spitzname bearbeiten',
  'pages.settings.nickname.form.label': 'Neuer Spitzname',
  'pages.settings.nickname.form.required': 'Bitte neuen Spitznamen eingeben',
  'pages.settings.nickname.form.length': 'Spitzname sollte 2-20 Zeichen lang sein',
  'pages.settings.nickname.updateSuccess': 'Spitzname erfolgreich aktualisiert',
  'pages.settings.nickname.updateFailed': 'Fehler beim Aktualisieren des Spitznamens',
  'pages.settings.registerTime.label': 'Registrierungszeit:',
  'pages.settings.email.label': 'E-Mail:',
  'pages.settings.email.unbind': 'Nicht gebunden',
  'pages.settings.email.bind': 'E-Mail binden',
  'pages.settings.email.change': 'E-Mail ändern',
  'pages.settings.email.modal.title': 'E-Mail binden',
  'pages.settings.email.modal.changeTitle': 'E-Mail ändern',
  'pages.settings.email.form.label': 'E-Mail',
  'pages.settings.email.form.required': 'Bitte E-Mail eingeben',
  'pages.settings.email.form.invalid': 'Ungültiges E-Mail-Format',
  'pages.settings.email.bindSuccess': 'E-Mail erfolgreich gebunden',
  'pages.settings.email.bindFailed': 'Fehler beim Binden der E-Mail',
  'pages.settings.changePassword.title': 'Passwort ändern',
  'pages.settings.changePassword.button': 'Passwort ändern',
  'pages.settings.changePassword.modal.title': 'Passwort ändern',
  'pages.settings.changePassword.oldPassword.label': 'Altes Passwort',
  'pages.settings.changePassword.oldPassword.required': 'Bitte altes Passwort eingeben',
  'pages.settings.changePassword.newPassword.label': 'Neues Passwort',
  'pages.settings.changePassword.newPassword.required': 'Bitte neues Passwort eingeben',
  'pages.settings.changePassword.newPassword.min': 'Neues Passwort muss mindestens 6 Zeichen haben',
  'pages.settings.changePassword.confirmPassword.label': 'Neues Passwort bestätigen',
  'pages.settings.changePassword.confirmPassword.required': 'Bitte neues Passwort bestätigen',
  'pages.settings.changePassword.confirmPassword.mismatch': 'Passwörter stimmen nicht überein',
  'pages.settings.changePassword.success': 'Passwort erfolgreich geändert',
  'pages.settings.changePassword.failed': 'Fehler beim Ändern des Passworts',
  'pages.settings.deleteAccount.title': 'Konto löschen',
  'pages.settings.deleteAccount.button': 'Konto löschen',
  'pages.settings.deleteAccount.confirm.title': 'Kontolöschung bestätigen?',
  'pages.settings.deleteAccount.confirm.content': 'Dieser Vorgang kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie Ihr Konto löschen möchten?',
  'pages.settings.deleteAccount.confirm.ok': 'Löschen',
  'pages.settings.deleteAccount.confirm.cancel': 'Abbrechen',
  'pages.settings.deleteAccount.success': 'Konto erfolgreich gelöscht',
  'pages.settings.deleteAccount.failed': 'Fehler beim Löschen des Kontos',
  'pages.settings.profile.fetchFailed': 'Fehler beim Abrufen der Benutzerinformationen',
  'pages.settings.form.submit': 'Absenden',
  'pages.settings.password.title': 'Passwort-Einstellungen',
  'pages.settings.basicInfo.username': 'Benutzername',
  'pages.settings.basicInfo.nickname': 'Spitzname',
  'pages.settings.basicInfo.avatar': 'Avatar',
  'pages.settings.basicInfo.editNickname': 'Spitzname bearbeiten',
  'pages.settings.basicInfo.editNicknameTitle': 'Spitzname bearbeiten',
  'pages.settings.basicInfo.newNicknameLabel': 'Neuer Spitzname',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'Spitzname erfolgreich geändert',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': 'Absenden',
  'pages.settings.deleteAccount.confirmTitle': 'Kontolöschung bestätigen',
  'pages.settings.deleteAccount.confirmContent': 'Nach der Löschung Ihres Kontos werden alle Ihre Daten dauerhaft gelöscht und können nicht wiederhergestellt werden, und Sie können sich nicht mehr mit diesem Konto anmelden. Bitte vorsichtig vorgehen!',
  'pages.settings.deleteAccount.cancel': 'Abbrechen',
  'pages.settings.deleteAccount.confirm': 'Löschung bestätigen',
  
  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'Benutzeranzahl',
  'pages.admin.dashboard.deviceCount': 'Geräteanzahl', 
  'pages.admin.dashboard.agentCount': 'Agentenanzahl',
  'pages.admin.dashboard.onlineUsers': 'Online-Benutzer',
  'pages.admin.dashboard.sessionDevices': 'Sitzungsgeräte',
  'pages.admin.dashboard.memoryUsage': 'Speichernutzung',
  'pages.admin.dashboard.cpuUsage': 'CPU-Nutzung',
  'pages.admin.dashboard.fetchError': 'Fehler beim Abrufen der Daten',
  'pages.admin.dashboard.networkError': 'Netzwerkfehler',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'Benutzername',
  'pages.admin.user.email': 'E-Mail',
  'pages.admin.user.status': 'Status',
  'pages.admin.user.status.all': 'Alle',
  'pages.admin.user.status.disabled': 'Deaktiviert',
  'pages.admin.user.status.normal': 'Normal',
  'pages.admin.user.quotaUsed': 'Tägliches Kontingent verwendet',
  'pages.admin.user.quotaTotal': 'Tägliches Gesamtkontingent',
  'pages.admin.user.createdAt': 'Erstellt am',
  'pages.admin.user.operations': 'Operationen',
  'pages.admin.user.edit': 'Bearbeiten',
  'pages.admin.user.detail': 'Details',
  'pages.admin.user.editModal.title': 'Benutzer bearbeiten',
  'pages.admin.user.status.label': 'Benutzerstatus',
  'pages.admin.user.status.enable': 'Aktivieren',
  'pages.admin.user.status.disable': 'Deaktivieren',
  'pages.admin.user.quotaUsed.label': 'Tägliches Kontingent verwendet',
  'pages.admin.user.quotaTotal.label': 'Tägliches Gesamtkontingent',
  'pages.admin.user.email.label': 'E-Mail',
  'pages.admin.user.save.success': 'Erfolgreich gespeichert',
  'pages.admin.user.save.failed': 'Speichern fehlgeschlagen',
  'pages.admin.user.list.title': 'Benutzerliste',

  // Admin Model Providers
  'pages.admin.providers.title': 'Modellanbieter-Verwaltung',
  'pages.admin.providers.total': 'Insgesamt {total} Anbieter',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.addNew': 'Neuen Anbieter hinzufügen',
  'pages.admin.providers.search.placeholder': 'Anbietername, Endpunkt oder Modell suchen...',
  'pages.admin.providers.filter.all': 'Alle Typen',
  'pages.admin.providers.filter.asr': 'ASR - Spracherkennung',
  'pages.admin.providers.filter.tts': 'TTS - Text zu Sprache', 
  'pages.admin.providers.filter.llm': 'LLM - Großes Sprachmodell',
  'pages.admin.providers.filter.vlllm': 'VLLLM - Vision-Sprachmodell',
  'pages.admin.providers.empty.noProviders': 'Noch keine Anbieter',
  'pages.admin.providers.empty.noMatches': 'Keine passenden Anbieter gefunden',
  'pages.admin.providers.empty.addFirst': 'Klicken Sie die Schaltfläche oben, um Ihren ersten Modellanbieter hinzuzufügen',
  'pages.admin.providers.empty.adjustFilters': 'Versuchen Sie, Suchkriterien oder Filter anzupassen',
  'pages.admin.providers.type.asr': 'ASR - Spracherkennung',
  'pages.admin.providers.type.tts': 'TTS - Text zu Sprache',
  'pages.admin.providers.type.llm': 'LLM - Großes Sprachmodell',
  'pages.admin.providers.type.vlllm': 'VLLLM - Vision-Sprachmodell',
  'pages.admin.providers.success.created': 'Anbieter erfolgreich hinzugefügt!',
  'pages.admin.providers.success.updated': 'Anbieter erfolgreich aktualisiert!',
  'pages.admin.providers.success.deleted': 'Anbieter erfolgreich gelöscht!',
  'pages.admin.providers.success.statusToggled': 'Status erfolgreich umgeschaltet!',
  'pages.admin.providers.error.createFailed': 'Fehler beim Hinzufügen des Anbieters, bitte versuchen Sie es erneut',
  'pages.admin.providers.error.updateFailed': 'Fehler beim Aktualisieren des Anbieters, bitte versuchen Sie es erneut',
  'pages.admin.providers.error.deleteFailed': 'Fehler beim Löschen des Anbieters, bitte versuchen Sie es erneut',
  'pages.admin.providers.error.testFailed': 'Verbindungstest fehlgeschlagen, bitte überprüfen Sie Netzwerk oder Konfiguration',
  'pages.admin.providers.error.toggleFailed': 'Fehler beim Umschalten des Status, bitte versuchen Sie es erneut',
  'pages.admin.providers.error.loadFailed': 'Fehler beim Laden der Anbieterliste, bitte aktualisieren Sie die Seite',

  // Admin Settings
  'pages.admin.settings.title': 'Systemeinstellungen',
  'pages.admin.settings.asr.label': 'ASR-Service',
  'pages.admin.settings.asr.placeholder': 'ASR-Service auswählen',
  'pages.admin.settings.tts.label': 'TTS-Service',
  'pages.admin.settings.tts.placeholder': 'TTS-Service auswählen',
  'pages.admin.settings.llm.label': 'LLM-Service',
  'pages.admin.settings.llm.placeholder': 'LLM-Service auswählen',
  'pages.admin.settings.vlllm.label': 'VLLLM-Service',
  'pages.admin.settings.vlllm.placeholder': 'VLLLM-Service auswählen',
  'pages.admin.settings.prompt.label': 'Prompt-Einstellungen',
  'pages.admin.settings.prompt.placeholder': 'Bitte System-Prompt eingeben...',
  'pages.admin.settings.quickReply.label': 'Schnellantwort-Wörter',
  'pages.admin.settings.quickReply.placeholder': 'Neues Schnellantwort-Wort eingeben',
  'pages.admin.settings.quickReply.add': 'Hinzufügen',
  'pages.admin.settings.deleteAudio.label': 'Audio löschen',
  'pages.admin.settings.deleteAudio.enabled': 'Aktiviert',
  'pages.admin.settings.deleteAudio.disabled': 'Deaktiviert',
  'pages.admin.settings.usePrivateConfig': 'Private Konfiguration verwenden',
  'pages.admin.settings.save': 'Konfiguration speichern',
  'pages.admin.settings.saving': 'Speichere...',
  'pages.admin.settings.reset': 'Zurücksetzen',
  'pages.admin.settings.success.saved': 'Konfiguration erfolgreich gespeichert!',
  'pages.admin.settings.error.saveFailed': 'Fehler beim Speichern der Konfiguration, bitte versuchen Sie es erneut',
  'pages.admin.settings.error.loadFailed': 'Fehler beim Laden der Konfiguration, bitte aktualisieren Sie die Seite und versuchen Sie es erneut',


  // Add Device Dialog
  'pages.addDevice.modal.title': 'Gerät hinzufügen',
  'pages.addDevice.verificationCode.label': 'Verifizierungscode:',
  'pages.addDevice.verificationCode.placeholder': 'Bitte den 6-stelligen Verifizierungscode vom Gerät eingeben',
  'pages.addDevice.verificationCode.required': 'Bitte einen 6-stelligen Verifizierungscode eingeben',
  'pages.addDevice.verificationCode.error': 'Bitte einen 6-stelligen Verifizierungscode eingeben',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'Anbieter bearbeiten',
  'pages.admin.providerModal.add.title': 'Neuen Anbieter hinzufügen',
  'pages.admin.providerModal.name.label': 'Anbietername *',
  'pages.admin.providerModal.name.placeholder': 'z.B.: OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': 'Bitte Anbieternamen eingeben',
  'pages.admin.providerModal.type.label': 'Service-Kategorie *',
  'pages.admin.providerModal.subType.label': 'Spezifischer Typ *',
  'pages.admin.providerModal.subType.required': 'Bitte spezifischen Typ auswählen',
  'pages.admin.providerModal.config.title': 'Konfiguration',
  'pages.admin.providerModal.api.url.label': 'API-URL *',
  'pages.admin.providerModal.api.url.required': 'Bitte API-URL eingeben',
  'pages.admin.providerModal.model.name.label': 'Modellname *',
  'pages.admin.providerModal.model.name.required': 'Bitte Modellnamen eingeben',
  'pages.admin.providerModal.api.key.label': 'API-Schlüssel *',
  'pages.admin.providerModal.api.key.required': 'Bitte API-Schlüssel eingeben',
  'pages.admin.providerModal.temperature.label': 'Temperatur (0-2)',
  'pages.admin.providerModal.temperature.error': 'Temperatur sollte zwischen 0-2 liegen',
  'pages.admin.providerModal.maxTokens.label': 'Max. Tokens',
  'pages.admin.providerModal.maxTokens.error': 'Max. Tokens sollten zwischen 1-32768 liegen',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'App-ID *',
  'pages.admin.providerModal.appid.required': 'Bitte App-ID eingeben',
  'pages.admin.providerModal.accessToken.label': 'Zugriffstoken *',
  'pages.admin.providerModal.accessToken.required': 'Bitte Zugriffstoken eingeben',
  'pages.admin.providerModal.cluster.label': 'Cluster',
  'pages.admin.providerModal.grpc.host.label': 'gRPC-Host *',
  'pages.admin.providerModal.grpc.host.required': 'Bitte gRPC-Host-Adresse eingeben',
  'pages.admin.providerModal.grpc.port.label': 'gRPC-Port *',
  'pages.admin.providerModal.grpc.port.required': 'Bitte gRPC-Port eingeben',
  'pages.admin.providerModal.voice.label': 'Stimme *',
  'pages.admin.providerModal.voice.required': 'Bitte Stimmtyp eingeben',
  'pages.admin.providerModal.token.label': 'Token *',
  'pages.admin.providerModal.token.required': 'Bitte Token eingeben',
  'pages.admin.providerModal.websocket.label': 'WebSocket-URL *',
  'pages.admin.providerModal.websocket.required': 'Bitte WebSocket-URL eingeben',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'API-Schlüssel *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'Bitte API-Schlüssel eingeben',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'API-URL',
  'pages.admin.providerModal.manage.voices': 'Stimmen verwalten',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS benötigt keine zusätzliche Konfiguration',
  'pages.admin.providerModal.submit.error': 'Übermittlung fehlgeschlagen, bitte versuchen Sie es erneut',

  // Provider Card
  'pages.admin.providerCard.status.active': 'Aktiv',
  'pages.admin.providerCard.status.inactive': 'Offline',
  'pages.admin.providerCard.status.error': 'Fehler',
  'pages.admin.providerCard.status.unknown': 'Unbekannt',
  'pages.admin.providerCard.warning.readonly.test': 'Nur-Lese-Berechtigung, kann Anbieter nicht testen',
  'pages.admin.providerCard.warning.readonly.delete': 'Nur-Lese-Berechtigung, kann Anbieter nicht löschen',
  'pages.admin.providerCard.warning.readonly.edit': 'Nur-Lese-Berechtigung, kann Anbieter nicht bearbeiten',
  'pages.admin.providerCard.warning.readonly.toggle': 'Nur-Lese-Berechtigung, kann Status nicht umschalten',
  'pages.admin.providerCard.button.disable': 'Deaktivieren',
  'pages.admin.providerCard.button.enable': 'Aktivieren',
  'pages.admin.providerCard.button.testing': 'Teste...',
  'pages.admin.providerCard.button.test': 'Testen',
  'pages.admin.providerCard.button.edit': 'Bearbeiten',
  'pages.admin.providerCard.button.delete': 'Löschen',
  'pages.admin.providerCard.delete.title': 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
  'pages.admin.providerCard.delete.content': 'Es kann nach dem Löschen nicht wiederhergestellt werden, bitte bestätigen Sie den Vorgang.',
  'pages.admin.providerCard.config.type': 'Typ',
  'pages.admin.providerCard.config.apiUrl': 'API-URL',
  'pages.admin.providerCard.config.model': 'Modell',
  'pages.admin.providerCard.config.apiKey': 'API-Schlüssel',
  'pages.admin.providerCard.config.temperature': 'Temperatur',
  'pages.admin.providerCard.config.maxTokens': 'Max. Tokens',
  'pages.admin.providerCard.config.appid': 'App-ID',
  'pages.admin.providerCard.config.cluster': 'Cluster',
  'pages.admin.providerCard.config.accessToken': 'Zugriffstoken',
  'pages.admin.providerCard.config.grpcHost': 'gRPC-Host',
  'pages.admin.providerCard.config.grpcPort': 'gRPC-Port',
  'pages.admin.providerCard.config.voice': 'Stimme',
  'pages.admin.providerCard.config.format': 'Format',
  'pages.admin.providerCard.config.token': 'Token',
  'pages.admin.providerCard.config.outputDir': 'Ausgabeverzeichnis',
  'pages.admin.providerCard.voices.supported': 'Unterstützte Stimmen',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': 'Test fehlgeschlagen',

    // OpsManage
  'pages.admin.ops.service.title': 'Service-Verwaltung',
  'pages.admin.ops.upload.button': 'Service-Datei hochladen',
  'pages.admin.ops.upload.success': 'Service-Datei erfolgreich hochgeladen',
  'pages.admin.ops.upload.error': 'Service-Datei-Upload fehlgeschlagen',
  'pages.admin.ops.restart.button': 'Service neu starten',
  'pages.admin.ops.restart.confirmTitle': 'Achtung: Sind Sie sicher, dass Sie den Service neu starten möchten?',
  'pages.admin.ops.restart.desc': 'Das Neustarten des Services wird alle aktuellen Verbindungen trennen und den Service vorübergehend nicht verfügbar machen.',
  'pages.admin.ops.restart.warn': 'Dieser Vorgang stoppt nur den aktuellen Service-Prozess. Bitte stellen Sie sicher, dass ein Daemon oder Auto-Restart-Skript auf dem Server konfiguriert ist, andernfalls wird sich der Service nicht automatisch wiederherstellen!',
  'pages.admin.ops.restart.ok': 'Neustart bestätigen',
  'pages.admin.ops.restart.cancel': 'Abbrechen',
  'pages.admin.ops.restart.success': 'Service-Neustart-Befehl gesendet',
  'pages.admin.ops.restart.error': 'Service-Neustart fehlgeschlagen',
  'pages.admin.ops.log.title': 'Log-Anzeige & Download',
  'pages.admin.ops.web.upload.button': 'web.zip hochladen',
  'pages.admin.ops.web.upload.success': 'web.zip erfolgreich hochgeladen',
  'pages.admin.ops.web.upload.error': 'web.zip-Upload fehlgeschlagen',
  'pages.admin.ops.web.upload.onlyzip': 'Nur ZIP-Dateien sind erlaubt',
  'pages.admin.ops.web.update.button': 'Web-Verzeichnis aktualisieren',
  'pages.admin.ops.web.update.success': 'Web-Verzeichnis-Update-Befehl gesendet',
  'pages.admin.ops.web.update.error': 'Web-Verzeichnis-Update fehlgeschlagen',
  'pages.admin.ops.web.upload.onlywebzip': 'Nur eine Datei namens web.zip ist erlaubt',

  // Recorder Management
  'pages.admin.recorder.title': 'Geräte-Recorder-Verwaltung',
  'pages.admin.recorder.inputDeviceId': 'Bitte Geräte-ID eingeben',
  'pages.admin.recorder.inputPlaceholder': 'Bitte Geräte-ID eingeben',
  'pages.admin.recorder.search': 'Suchen',
  'pages.admin.recorder.list.title': 'Recorder-Liste',
  'pages.admin.recorder.fetchSuccess': 'Recorder-Aufzeichnungen erfolgreich abgerufen',
  'pages.admin.recorder.fetchError': 'Fehler beim Abrufen der Recorder-Liste',
  'pages.admin.recorder.empty': 'Keine Recorder-Daten, bitte Geräte-ID eingeben, um zu suchen',
  'pages.admin.recorder.totalCount': 'Statistiken',
  'pages.admin.recorder.conversationId': 'Unterhaltungs-ID',

  'pages.agentSetting.mcp.modal.title': 'MCP-Zugangspunkt-Einstellungen',
  'pages.agentSetting.mcp.modal.statusLabel': 'Zugangspunkt-Status',
  'pages.agentSetting.mcp.modal.online': 'Online',
  'pages.agentSetting.mcp.modal.disconnected': 'Getrennt',
  'pages.agentSetting.mcp.modal.unknown': 'Unbekannt',
  'pages.agentSetting.mcp.modal.refresh': 'Aktualisieren',
  'pages.agentSetting.mcp.modal.enabledServices': 'Aktivierte Dienste',
  'pages.agentSetting.mcp.modal.endpointLabel': 'Zugangspunkt-Adresse',
  'pages.agentSetting.mcp.modal.endpointDesc': 'Unten befindet sich die MCP-Zugangspunkt-Adresse des Agents.',
  'pages.agentSetting.mcp.modal.docLink': 'Dokumentation zum Zugangspunkt anzeigen',
  'pages.agentSetting.mcp.modal.noEndpoint': 'Kein verfügbarer Zugangspunkt',
  'pages.agentSetting.mcp.modal.hide': 'Verstecken',
  'pages.agentSetting.mcp.title': 'MCP-Einstellungen', 
  'pages.agentSetting.mcp.customService': 'Benutzerdefinierter Dienst',
  'pages.agentSetting.mcp.officialServices': 'Offizielle Dienste',
  'pages.agentSetting.mcp.officialServices.placeholder': 'Wählen Sie offizielle Dienste',
  'pages.agentSetting.mcp.services.weather': 'Wetter',
  'pages.agentSetting.mcp.services.joke': 'Witz',
  'pages.agentSetting.mcp.services.music': 'Musik',
  'pages.agentSetting.mcp.services.news': 'Nachrichten',
  'pages.agentSetting.mcp.error.missingId': 'Agent-ID fehlt, Zugangspunkt kann nicht abgerufen werden',
  'pages.agentSetting.mcp.error.noEndpoint': 'Kann Zugangspunkt nicht vom Server abrufen',
'pages.agentSetting.mcp.error.fetchFailed': 'Fehler beim Abrufen des Zugangspunkts',
  'pages.agentSetting.mcp.button.getEndpoint': 'MCP-Zugangspunkt abrufen',

  // Memory settings
  'pages.agentSetting.memory.title': 'Kurzzeitgedächtnis',
  'pages.agentSetting.memory.type.label': 'Speichertyp',
  'pages.agentSetting.memory.type.none': 'Kein Speicher',
  'pages.agentSetting.memory.type.shortTerm': 'Kurzzeitgedächtnis',
  'pages.agentSetting.memory.current.label.short': 'Aktueller Speicher',
  'pages.agentSetting.memory.current.help': 'Wird nach jedem Gespräch neu generiert',
  'pages.agentSetting.memory.clear': 'Speicher löschen',
  'pages.agentSetting.memory.clear.tip': 'Speicher zum Löschen markiert, bitte speichern Sie zum Übernehmen',
  'pages.agentSetting.memory.content.label': 'Speicherinhalt',
  'pages.agentSetting.memory.content.placeholder': 'Neuesten Kurzzeitgedächtnis-Inhalt des Agenten abrufen',
  'pages.agentSetting.memory.content.editPlaceholder': 'Bitte Speicherinhalt eingeben',
  'pages.agentSetting.memory.edit': 'Speicher bearbeiten',
  'pages.agentSetting.memory.edit.success': 'Speicher aktualisiert, bitte speichern zum Übernehmen',
  'pages.agentSetting.memory.edit.save': 'Änderungen speichern',
  'pages.agentSetting.memory.edit.cancel': 'Abbrechen',

  // Allgemeine Schaltflächen und Operationen
  'pages.common.cancel': 'Abbrechen',

  // Systemkonfiguration
  'pages.admin.systemConfig.roleName': 'Rollenname',
  'pages.admin.systemConfig.roleDesc': 'Rollenbeschreibung',
  'pages.admin.systemConfig.enabled': 'Aktivierter Status',
  'pages.admin.systemConfig.featureName': 'Funktionsname',
  'pages.admin.systemConfig.featureDesc': 'Funktionsbeschreibung',
  'pages.admin.systemConfig.exitCommand': 'Beenden-Befehl',
  'pages.admin.systemConfig.mcpName': 'MCP-Name',
  'pages.admin.systemConfig.newNameOptional': 'Neuer Name (optional)',
  'pages.admin.systemConfig.configJson': 'Konfiguration JSON',
  'pages.admin.systemConfig.useDeviceCode': 'Gerätecode verwenden',
  'pages.admin.systemConfig.quickReply': 'Schnelle Antwort',
  'pages.admin.systemConfig.shortTermMemory': 'Kurzzeitgedächtnis',
  'pages.admin.systemConfig.saveUserAudio': 'Benutzer-Audiodateien speichern',
  'pages.admin.systemConfig.enableWhiteList': 'Whitelist aktivieren',
  'pages.admin.systemConfig.speakerDetect': 'Spracherkennung',
  'pages.admin.systemConfig.recorderManagerEnable': 'Recorder-Management aktivieren',
  'pages.admin.systemConfig.voiceCloneEnable': 'Stimmklon aktivieren',
  'pages.admin.systemConfig.flattenedChatHistory': 'Ebenen Chatverlauf',
  'pages.admin.systemConfig.dialogueHistoryLength': 'Dialogverlaufslänge',
  'pages.admin.systemConfig.userTotalQuota': 'Gesamtes Benutzerkontingent',
  'pages.admin.systemConfig.dailyClearQuota': 'Tägliches Kontingent zurücksetzen',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'Gerätemodus sofort prüfen',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': 'Standard-Beobachterrolle für neue Benutzer',
  'pages.admin.systemConfig.status': 'Status',
  'pages.admin.systemConfig.port': 'Port',
  'pages.admin.systemConfig.udpShowPort': 'Port anzeigen',
  'pages.admin.systemConfig.accessToken': 'Zugriffstoken',
  'pages.admin.systemConfig.activateText': 'Aktivierungstext',
  'pages.admin.systemConfig.logLevel': 'Protokollierungsstufe',
  'pages.admin.systemConfig.logDir': 'Protokollverzeichnis',
  'pages.admin.systemConfig.logFileName': 'Protokolldateiname',

  // Stimmklon
  'pages.console.voiceClone.name': 'Name',
  'pages.console.voiceClone.provider': 'Anbieter',
  'pages.console.voiceClone.mode': 'Modus',
  'pages.console.voiceClone.record': 'Aufnehmen',
  'pages.console.voiceClone.upload': 'Hochladen',

  // Spracherkennung
  'pages.console.speakers.name': 'Name',
  'pages.console.speakers.mode': 'Modus',
  'pages.console.speakers.record': 'Aufnehmen',
  'pages.console.speakers.upload': 'Hochladen',

  // Einstellungsseite
  'pages.console.settings.email': 'E-Mail',
  'pages.console.settings.oldPassword': 'Altes Passwort',
  'pages.console.settings.newPassword': 'Neues Passwort',
  'pages.console.settings.confirmNewPassword': 'Neues Passwort bestätigen',

  // VLLM-Anbieter
  'pages.providers.vllm.maxPixels': 'Maximale Pixelanzahl',
  'pages.admin.providerModal.copyAsNew': 'Als neuen Anbieter kopieren',

  'pages.unbindDevice.cardTitle': 'Geräte-Entbindung',
  'pages.whiteList.cardTitle': 'Whitelist-Management',
  'pages.admin.ops.logViewer.previewTitle': 'Protokollvorschau',
  'pages.admin.ops.logViewer.fileName': 'Dateiname:',
  'pages.admin.ops.logViewer.lineCount': 'Zeilen:',
  'pages.admin.ops.logViewer.previewBtn': 'Vorschau',
  'pages.admin.ops.logViewer.noContent': 'Kein Inhalt',
  'pages.admin.devices': 'Geräteverwaltung',
  'pages.admin.unbindDevice': 'Gerät entbinden',
  'pages.admin.deviceManage': 'Geräteverwaltung',
  'pages.systemConfig.quickReply': 'Schnellantwort',
  'pages.systemConfig.useShortTermMemory': 'Kurzzeitgedächtnis',
  'pages.systemConfig.useShortTermMemory.desc': 'Wenn aktiviert, verwendet das System einen Kurzzeitgedächtnismechanismus und aktualisiert es nach jedem Dialogzug. Wenn deaktiviert, wird kein Kurzzeitgedächtnis verwendet.',
  'pages.agentSetting.mcp.modal.show': 'Anzeigen',
  'pages.agentSetting.mcp.modal.copied': 'Kopiert',
  'pages.agentSetting.mcp.modal.copy': 'Kopieren',
  'pages.admin.providerModal.model.label': 'Modell *',
  'pages.admin.providerModal.model.placeholder': 'Geben Sie den Modellnamen ein',
  'pages.admin.providerModal.model.required': 'Geben Sie den Modellnamen ein',
  'pages.admin.providerModal.security.title': 'Sicherheitseinstellungen',
  'pages.admin.providerModal.appid.placeholder': 'Doubao-App-ID',
  'pages.admin.providerModal.accessToken.placeholder': 'Zugriffstoken',
  'pages.admin.providerModal.grpc.addr.label': 'gRPC-Adresse (Host:Port) *',
  'pages.admin.providerModal.grpc.addr.required': 'Geben Sie die gRPC-Adresse (Host:Port) ein',
  'pages.admin.providerModal.token.placeholder': 'Doubao-Token',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'API-Schlüssel',
  'pages.admin.providerModal.manageVoices': 'Stimmen verwalten',
  'pages.admin.whiteList.inputMac': 'Geben Sie die MAC-Adresse ein',
  'pages.admin.whiteList.batchAdd': 'Stapelweise hinzufügen',
  'pages.admin.whiteList.add': 'Hinzufügen',
  'pages.admin.whiteList.list.title': 'MAC-Adressliste',
  'pages.admin.whiteList.selectCsvTip': 'Wählen Sie eine CSV-Datei aus',
  'pages.admin.whiteList.uploadSuccess': 'Hochladen erfolgreich',
  'pages.admin.whiteList.uploadFailed': 'Hochladen fehlgeschlagen',
  'pages.admin.whiteList.invalidMac': 'Geben Sie eine gültige MAC-Adresse ein',
  'pages.admin.settings.voiceCloneEnable': 'Stimmenklonen aktivieren',
  'pages.agentSetting.roleTemplate.empty': 'Keine Vorlagen verfügbar. Bitte prüfen Sie role_template.json',
  'pages.admin.providerModal.save': 'Speichern',
  'pages.contractDevice.cardTitle': 'Vertragsgeräteverwaltung',
  'pages.contractDevice.mac': 'MAC-Adresse',
  'pages.contractDevice.protocolType': 'Protokolltyp',
  'pages.contractDevice.status': 'Status',
  'pages.contractDevice.expireTime': 'Ablaufzeit',
  'pages.contractDevice.updateTime': 'Aktualisierungszeit',
  'pages.contractDevice.operations': 'Operationen',
  'pages.contractDevice.edit': 'Bearbeiten',
  'pages.contractDevice.delete': 'Löschen',
  'pages.contractDevice.deleteConfirm': 'Löschen bestätigen',
  'pages.contractDevice.addTitle': 'Vertragsgerät hinzufügen',
  'pages.contractDevice.batchAddTitle': 'Stapelweise hinzufügen',
  'pages.contractDevice.editTitle': 'Vertragsgerät bearbeiten',
  'pages.contractDevice.listTitle': 'Vertragsgeräteliste',
  'pages.contractDevice.add': 'Hinzufügen',
  'pages.contractDevice.batchAdd': 'Stapelweise hinzufügen',
  'pages.contractDevice.selectCsvTip': 'Wählen Sie eine CSV-Datei aus',
  'pages.contractDevice.uploadSuccess': 'Hochladen erfolgreich',
  'pages.contractDevice.macRequired': 'Geben Sie die MAC-Adresse ein',
  'pages.contractDevice.protocolTypeRequired': 'Wählen Sie den Protokolltyp',
  'pages.contractDevice.statusRequired': 'Wählen Sie den Status',
  'pages.contractDevice.expireTimeRequired': 'Wählen Sie die Ablaufzeit',
};